import React from "react";
import PropTypes from "prop-types";
import clsx from "classnames";
import { enums } from "../enums";
import { CustomHeader } from "components";
import "./style.scss";
import { Modal as BootstrapModal } from "react-bootstrap";

const Modal = ({
  showModal,
  onClose,
  size,
  className,
  style,
  modalTitle,
  titlePosition,
  titleVariant,
  titleState,
  children,
  customPadding,
  ...rest
}) => {
  const baseClass = "pm-modal";
  const modalClasses = clsx(baseClass, className);

  return (
    <BootstrapModal
      style={style}
      show={showModal}
      onHide={onClose}
      size={size}
      className={modalClasses}
      aria-labelledby={modalTitle || baseClass}
      centered
      {...rest}
    >
      {modalTitle && (
        <CustomHeader
          title={modalTitle}
          titlePosition={titlePosition}
          titleVariant={titleVariant}
          titleState={titleState}
          forModal={true}
        />
      )}
      <div className={customPadding ? customPadding : "px-4"}>{children}</div>
    </BootstrapModal>
  );
};

Modal.propTypes = {
  style: PropTypes.object,
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  size: PropTypes.oneOf(enums.componentSizes),
  modalTitle: PropTypes.string,
  customPadding: PropTypes.string,
};

Modal.defaultProps = {
  size: "md",
};

export default Modal;
